<template>
  <a-popover v-model="visible" trigger="click">
    <template slot="content">
      <a-row class="region_header">
        <a-col :span="6">
          <a @click="hide">取消</a>
        </a-col>
        <a-col class="region_center_title" :span="12"> 按省市选择 </a-col>
        <a-col class="region_right_title" :span="6">
          <a @click="CitySure">完成({{ citiesList.length }}/200)</a>
        </a-col>
      </a-row>
      <a-row>
        <a-col class="region_left_nav" :span="7">
          <div
            class="left_item"
            v-for="(item, index) in provinces"
            v-bind:class="{ region_item_checked: index == ProvinceChecked }"
            :key="item.id"
            v-on:click="ChooseProvince(item, index)"
          >
            <a-badge :count="item.value" :offset="[18, 0]">
              <span>{{ item.reg_name }}</span>
            </a-badge>
          </div>
        </a-col>
        <a-col class="region_right_box" :span="17">
          <a-checkbox @click="ChooseAll" :checked="isCheckedAll" v-if="cities.length>1 ">
            全选
          </a-checkbox>
          <div class="region_item_box">
						<div v-for="(city,index) in cities" :key="city.id" :class="citiesList.includes(city.id)?'region_item is_checked':'region_item'"  @click="citiesClick(city,index)">
              {{ city.reg_name }}
            </div>
          </div>
        </a-col>
      </a-row>
    </template>
    <a-button :class="styleSet">
      请选择省/市
      <a-icon type="down" />
    </a-button>
  </a-popover>
</template>

<script>
import { qcApi, requestHttp } from '@utils/index';
export default {
  name: "Region",
  props: ["styleSet"],
  data() {
    return {
      visible: false,
      ProvinceList: [],
      ProvinceChecked: 0,
      hasCityList: [],
      isCheckedAll: !1,
      hasProvubceId: 11e4,
      OriginList: [],
      CityList: [
        {
          id: 11,
          reg_name: "北京",
          isChecked: false,
        },
      ],
      provinces: [],
      cities: [],
      citiesList: [],
      citiesListstr: [],
    };
  },
  methods: {
    hide() {
      for (
        var t = this, a = t.ProvinceList, e = t.CityList, i = 0;
        i < a.length;
        i++
      )
        (a[i].isChecked = !1), (a[i].num = 0), (a[i].checkall = !1);
      for (i = 0; i < e.length; i++) e[i].isChecked = !1;
      this.visible = false;
      Object.assign(this, {
        area: [],
        isCheckedAll: !1,
        CityList: e,
        ProvinceList: a,
        hasCityList: [],
      });
      this.$emit("city-sure", { area: false, cityname: [], areaStr: {} });
    }, 
    CitySure() {
      if(this.citiesList.length == 0){
        this.$message.warning("至少选中1个城市")
      }else{
        this.visible = false;
        this.$emit("city-sure", {area:this.citiesList,areaStr: this.citiesListstr,cityname:this.citiesListstr });
      }
    },
    ChooseAll() {
      this.isCheckedAll = !this.isCheckedAll;
      let that = this
      if(this.isCheckedAll){ 
        console.log('222222',this.provinces[this.ProvinceChecked].childlist)
        this.provinces[this.ProvinceChecked].childlist.forEach(function(item,index){
          if( !that.citiesList.includes(item.id) ){
            that.citiesClick(item,index)
          }
        })
      }else{
        this.provinces[this.ProvinceChecked].childlist.forEach(function(item,index){
          if( that.citiesList.includes(item.id) ){ 
            item.state = true
            that.citiesClick(item,index)
          }
        }) 
      }
    },
    uniq: function (t) {
      for (var a = [], e = [], i = t.length, n = 0; n < i; n++) {
        for (var o = n + 1; o < i; o++) t[n].id === t[o].id && (o = ++n);
        a.push(t[n]), e.push(n);
      }
      return a;
    },
    citiesClick(item,index) {
      // item.state = !item.state;
      this.cities[index].state = !this.cities[index].state
      // this.query.citiesList = this.cities.filter(item=>item.state);     // 市  2021年10月25日16:14:03
      let selectCureenNum = this.cities.filter((item) => item.state); //11111 获取当前到市count
      console.log("selectCureenNum", selectCureenNum);
      let currentId = "";
      // // this.query.citiesList.length;//选中市的个数
      if (item.reg_parent_id > 0) {
        // // console.log(this.query.citiesList);
        currentId = this.provinces.findIndex((provincesItem) => {
          return provincesItem.id === item.reg_parent_id;
        });  
      } else {
        currentId = this.provinces.findIndex((provincesItem) => {
          return provincesItem.id === item.id;
        }); 
      }
      // // this.$set(this.provinces[currentId],'value',this.query.citiesList.length);//给数组赋值  2021年10月25日16:13:49
      this.$set(this.provinces[currentId], "value", selectCureenNum.length); // 1111
      this.$set(
        this.provinces[currentId],
        "isshownum",
        selectCureenNum.length > 0
      ); //给数组赋值 判断大于0才显示个数

      let list = [];
      let liststr = [];
      this.provinces.forEach((item) => {
        if (item.isshownum) {
          if (item.childlist.length > 0) {
            item.childlist.forEach((it) => {
              if (it.state) {
                list.push(it.id);
                liststr.push(it.reg_name);
              }
            });
          } else {
            if (item.state) {
              list.push(item.id);
              liststr.push(item.reg_name);
            }
          }
        }
      });
      this.citiesList = [...list];
      this.citiesListstr = [...liststr];
      console.log(this.citiesList); 
    },
    ChooseProvince(item, index) {
      
      this.ProvinceChecked = index;
      this.provinces.forEach(function(item){
				item.newstate = false
			})
			item.newstate = true;
			// let aaa = this.provinces.filter(item=>item.state);   //省
			if(this.provinces[index].childlist.length>0){
				this.cities=this.provinces[index].childlist;
			}else{ 
				this.cities=[this.provinces[index]]
			}
      let status = true
      let that = this
      this.cities.forEach(function(item){
        if(that.citiesList.includes(item.id)){
          status = false
        }
      })
      this.isCheckedAll = !status 
    },
    async getRegion(){
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_SXT_REGION}`,
        method: 'POST',
        params:{
          level: 2
        } 
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.provinces = data;
      this.cities = [data[0]]
    }
  },
  created: function () {
    // getArea({ level: 2 }).then(this.afterGetArea);

      this.getRegion();

  },
};
</script>
<style lang="less" scoped>
.region_header {
  width: 100%;
  height: 45px;
  border-bottom: 2px solid #f1f3f8;
  padding: 0 20px;
  line-height: 45px;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.region_center_title {
  text-align: center;
  font-size: 16px;
}
.region_right_title {
  text-align: right;
}
.region_right_title a {
  color: red;
}
.region_left_nav {
  height: 280px;
  border-right: 1px solid #f1f3f8;
  overflow: auto;
}
.region_right_box {
  height: 260px;
  padding: 16px;
}
.left_item {
  width: 100%;
  height: 41px;
  line-height: 41px;
  text-align: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.85);
}
.region_item_box {
  width: 412px;
  margin-top: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.region_item {
  width: 60px;
  height: 32px;
  font-size: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0 10px 10px 0;
  border: 1px solid rgb(217, 217, 217);
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
}
.region_item:hover {
  border-color: #1890ff;
  color: #1890ff;
}
.is_checked {
  background: #ffffff;
  border-color: #1890ff;
  color: #1890ff;
}
.region_item_checked {
  color: #1890ff;
}
.left_item:hover {
  color: #1890ff;
}
</style>